import React from "react";
import { Navigate } from "react-router-dom";
import { getRolActual, getHomePorRol } from "../utils/rolUtils";

const AuthRedirect = ({ children }) => {
  const token = localStorage.getItem("token");
  const isAuth = token !== null;

  if (isAuth) {
    const rol = getRolActual();
    return <Navigate to={getHomePorRol(rol)} replace />;
  }

  return children;
};

export default AuthRedirect;